import React, { useEffect, useState } from "react";
import api from "../../services/api";

const FirmReports = () => {
  const [aum, setAum] = useState(null);
  const [ladder, setLadder] = useState(null);
  const [asOf, setAsOf] = useState("");
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [error, setError] = useState("");

  const loadReports = async () => {
    setError("");
    try {
      const [aumData, ladderData] = await Promise.all([
        api.firmReportAum(asOf ? { as_of: asOf } : {}),
        api.firmReportMaturityLadder({ start: start || undefined, end: end || undefined }),
      ]);
      setAum(aumData);
      setLadder(ladderData);
    } catch (err) {
      setError(err.message || "Failed to load reports.");
    }
  };

  useEffect(() => {
    loadReports();
  }, []);

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-xl font-semibold text-slate-900">Firm Reports</h1>
          <p className="text-sm text-slate-500">AUM, maturity ladder, and cashflow outlook.</p>
        </div>
        <button
          onClick={loadReports}
          className="rounded-lg border border-slate-200 px-3 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100"
        >
          Refresh
        </button>
      </div>

      {error && (
        <div className="rounded-lg border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
          {error}
        </div>
      )}

      <div className="grid gap-4 lg:grid-cols-3">
        <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
          <p className="text-xs uppercase text-slate-400">AUM as of</p>
          <input
            type="date"
            className="mt-2 w-full rounded-lg border border-slate-200 px-3 py-2 text-sm"
            value={asOf}
            onChange={(e) => setAsOf(e.target.value)}
          />
          <button
            onClick={loadReports}
            className="mt-3 w-full rounded-lg bg-slate-900 px-3 py-2 text-sm font-semibold text-white"
          >
            Update AUM
          </button>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
          <p className="text-xs uppercase text-slate-400">Maturity ladder</p>
          <div className="mt-2 grid gap-2">
            <input
              type="date"
              className="rounded-lg border border-slate-200 px-3 py-2 text-sm"
              value={start}
              onChange={(e) => setStart(e.target.value)}
              placeholder="Start date"
            />
            <input
              type="date"
              className="rounded-lg border border-slate-200 px-3 py-2 text-sm"
              value={end}
              onChange={(e) => setEnd(e.target.value)}
              placeholder="End date"
            />
          </div>
          <button
            onClick={loadReports}
            className="mt-3 w-full rounded-lg bg-emerald-600 px-3 py-2 text-sm font-semibold text-white"
          >
            Update ladder
          </button>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm">
          <p className="text-xs uppercase text-slate-400">Totals</p>
          <div className="mt-2 text-sm text-slate-600">
            {aum?.totals_by_currency
              ? Object.entries(aum.totals_by_currency).map(([currency, value]) => (
                  <div key={currency} className="flex justify-between">
                    <span>{currency}</span>
                    <span>{Number(value).toLocaleString()}</span>
                  </div>
                ))
              : "No data"}
          </div>
        </div>
      </div>

      <div className="grid gap-6 lg:grid-cols-2">
        <div className="rounded-xl border border-slate-200 bg-white shadow-sm">
          <div className="border-b border-slate-100 px-4 py-3 text-sm font-semibold">AUM Breakdown</div>
          <div className="p-4 text-sm text-slate-600 space-y-2">
            {aum?.totals_by_asset
              ? Object.entries(aum.totals_by_asset).map(([asset, value]) => (
                  <div key={asset} className="flex justify-between">
                    <span className="capitalize">{asset}</span>
                    <span>{Number(value).toLocaleString()}</span>
                  </div>
                ))
              : "No data"}
          </div>
        </div>
        <div className="rounded-xl border border-slate-200 bg-white shadow-sm">
          <div className="border-b border-slate-100 px-4 py-3 text-sm font-semibold">Maturity Ladder</div>
          <div className="p-4 text-sm text-slate-600 space-y-2">
            {ladder?.buckets
              ? Object.entries(ladder.buckets).map(([bucket, value]) => (
                  <div key={bucket} className="flex justify-between">
                    <span>{bucket}</span>
                    <span>{Number(value).toLocaleString()}</span>
                  </div>
                ))
              : "No data"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FirmReports;
